import { v4 } from 'uuid';
import { Entity } from '../../../../common/ddd/entity.base';
import { ChallengeDigitalIntensityEntity } from '../../entities/challenge-insights/digital-intensity/challenge-digital-intensity.entity';

export interface ChallengeDigitalIntensityAggregateRootProps {
  before: ChallengeDigitalIntensityEntity;
  after: ChallengeDigitalIntensityEntity;
}

export class ChallengeDigitalIntensityAggregateRoot extends Entity<ChallengeDigitalIntensityAggregateRootProps> {
  protected _id: string;
  static create(
    props: ChallengeDigitalIntensityAggregateRootProps,
    entityId?: string
  ): ChallengeDigitalIntensityAggregateRoot {
    const id = entityId || v4();
    const entity = new ChallengeDigitalIntensityAggregateRoot({
      id,
      props,
    });
    return entity;
  }
  public validate(): void {}
  get metricType() {
    return this.props.after.metricType;
  }
  get beforeValue() {
    return this.props.before.value;
  }
  get beforeCount() {
    return this.props.before.count;
  }
  get value() {
    return this.props.after.value;
  }
  get count() {
    return this.props.after.count;
  }
  get deviation() {
    return this.value - this.beforeValue;
  }
  get deviationPercentage() {
    return this.deviation;
  }
  get beforeAverage() {
    return this.beforeCount !== 0
      ? this.beforeValue / this.beforeCount
      : this.beforeValue;
  }
  get average() {
    return this.count !== 0 ? this.value / this.count : this.value;
  }
  get averageDeviation() {
    return this.average - this.beforeAverage;
  }
  get averageDeviationPercentage() {
    return this.averageDeviation;
  }

  get afterUniqueUsersCount(): number {
    return this.props.after.uniqueUsers;
  }

  get beforeUniqueUsersCount(): number {
    return this.props.before.uniqueUsers;
  }
}
